import Vue from 'vue';
import axios from 'axios';
export default {
    install(Vue, options) {
        Vue.prototype.$getSafe = function (fn) {
            try {
                return fn();
            } catch (e) {
                return ""
            }
        };
        Vue.prototype.$vuePublicPath = function (asset) {
            return process.env.BASE_URL + "public" + asset;
        };
        Vue.prototype.$resizeImage = function (path, width, height, quality, crop) {
            return path.resizeImage(width, height, quality, crop);
        };
        Vue.prototype.$preload = function (href, as) {
            if (isBrowser) {
                let link = document.createElement('link');
                link.setAttribute('rel', 'preload');
                link.setAttribute('href', href);
                link.setAttribute('as', as);
                document.head.appendChild(link);
            }
        };
        Vue.prototype.$getMetaTags = function (name, description, img) {

            return [
                {
                    name: "title",
                    content: name || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    name: "description",
                    content: description || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    name: "image",
                    content: img || "https://planetcricket.com/public/images/logo1280x720.png"
                },
                {
                    itemprop: "name",
                    content: name || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    itemprop: "description",
                    content: description || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    itemprop: "image",
                    content: img || "https://planetcricket.com/public/images/logo1280x720.png"
                },
                {
                    property: "og:url",
                    content: process.env.BASE_URL + this.$route.fullPath.substring(1)
                },
                {
                    property: "og:type",
                    content: "website"
                },
                {
                    property: "og:title",
                    content: name || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    property: "og:description",
                    content: description || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    property: "og:image",
                    content: img || "https://planetcricket.com/public/images/logo1280x720.png"
                },

                {
                    name: "twitter:card",
                    content: "summary_large_image"
                },
                {
                    name: "twitter:title",
                    content: name || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    name: "twitter:description",
                    content: description || "All Cricket Matches, Score, Update, Schedule, Upcoming | Planet Cricket"
                },
                {
                    name: "twitter:image",
                    content: img || "https://planetcricket.com/public/images/logo1280x720.png"
                },
            ]

        };
//        Vue.prototype.$refreshComponent = function () {
//            if (this.$parent.$options.name) {
//                Components[this.$parent.$options.name + ''].reload++;
//            }
//        };
//        Vue.prototype.$redirectByRouteName = function (routeName, queryString) {
//            queryString = queryString || '';
//            window.location = this.getObjectById(this.$router.options.routes.concat(this.$router.options.routes.map(o => o.children).filter(o => o).reduce((acc, val) => acc.concat(val), [])), routeName, 'name').path + queryString;
//        };
//        Vue.prototype.$getRouteByName = function (routeName) {
//            return this.getObjectById(this.$router.options.routes.concat(this.$router.options.routes.map(o => o.children).filter(o => o).reduce((acc, val) => acc.concat(val), [])), routeName, 'name');
//        };
//        Vue.prototype.$dynamicValidation = function (field) {
//            if (field && field.extra.validation) {
//                if (field.is_required) {
//                    field.extra.validation['required'] = true;
//                }
//                return field.extra.validation;
//            } else {
//                return '';
//            }
//        };
        Vue.prototype.$loadScript = function (url) {
            let script = document.createElement('script');
            script.setAttribute('src', url);
            document.head.appendChild(script);
        };
//        Vue.prototype.$uploadGeneralFile = function (file, path) {
//            return new Promise((resolve, reject) => {
//                const formData = new FormData();
//                formData.append('file', file);
//                formData.append('path', path);
//                axios({
//                    method: 'post',
//                    data: formData,
//                    url: this.UPLOAD_GEN_FILE,
//                    headers: this.getImageHeader()
//                }).then(response => {
//                    if (response.data.status === 200) {
//                        resolve(response);
//                    } else {
//                        console.log("API Error: " + response.data.message);
//                    }
//                }).catch(error => {
//                    console.log(error);
//                    reject(error);
//                });
//            })
//        };
//        Vue.prototype.loadComponent = function (compName, compFolder, props, cssProperties, modalEvents) {
//            props = props || {};
//            modalEvents = modalEvents || {};
//            cssProperties = cssProperties || {};
//            if (isMobile) {
//                cssProperties.width = '80%';
//            }
//            switch (compFolder) {
//            case "Feeds":
//                    var myComponent = () => import('@/components/Feeds/' + compName);
//                    break;
//                    case "Matches":
//                    var myComponent = () => import('@/components/Matches/' + compName);
//                    break;
//                    default:
//                    var myComponent = () => import('@/components/Models/' + compName);
//                    break;
//
//        }
//
//        this.$modal.show(myComponent, props, cssProperties, modalEvents);
//        setTimeout(function () {
//            if ($(".v--modal-overlay.scrollable .v--modal-box").height() > $(window).height()) {
//                $(".v--modal-overlay.scrollable .v--modal-box").css('margin', '53px 0');
//            }
//        }, 500);
//        }
//        window.loadComponent = function (compName, compFolder, props, cssProperties, modalEvents) {
//            window.$root.loadComponent(compName, compFolder, props, cssProperties, modalEvents);
//        }
//        Vue.prototype.$refreshObject = function (object, updateProperties) {
//            updateProperties = updateProperties || {};
//            return object = Object.assign({}, object, updateProperties);
//        };
//
//        Vue.prototype.$copyObj = function (obj) {
//            return $.extend(true, {}, obj);
//        };

        //----------------------Global Uploader for image------------------uploadAndGetPath('pollOptions',option,'image')
//        Vue.prototype.onUpload = function () {};
//        Vue.prototype.uploadParams = {};
//        Vue.prototype.uploadAndGetPath = function (folderPath, model, property) {
//            Vue.prototype.uploadParams = {path: folderPath || 'temp'};
//            property = property || 'image';
//            Vue.prototype.onUpload = function (jsonData) {
//                model[property] = jsonData.result.relative_path;
//                Components['app'].$refs.image_uploader_global.off();
//            };
//            window.$root.imageBoxFlagGlobal = !window.$root.imageBoxFlagGlobal;
//        };
//        //----------------Global Uploader for File--------------------------globalGenralFileUploader('pollOptions',option)
//        Vue.prototype.globalGenralFileUploader = function (folderPath, model, property) {
//            property = property || 'image';
//            var temp = window.clickedElement;
//            $("#genralFileUploader").click();
//
//            $("#genralFileUploader").off('change').change(function () {
//                window.clickedElement = temp;
//                const formData = new FormData();
//                formData.append('file', this.files[0]);
//                formData.append('path', folderPath || 'temp');
//                axios({
//                    method: 'post',
//                    data: formData,
//                    url: window.$root.UPLOAD_GEN_FILE,
//                    headers: window.$root.getImageHeader()
//                }).then(response => {
//                    if (response.data.status === 200) {
//                        model[property] = response.data.result.relative_path;
//                        $("#genralFileUploader").val('');
//                    } else {
//                        console.log("API Error: " + response.data.message);
//                    }
//                }).catch(error => {
//                    console.log(error);
//                });
//
//            });
//
//
//        };



    }};